import { useState, useRef, useCallback } from 'react';

/**
 * In-flight guard for the paused card's Resume action. Wraps an async handler so a
 * double-click can't fire two reopens; `resuming` disables the button, and the
 * guard is always released in `finally` so a failed reopen never leaves it stuck.
 */
export default function useResumeGuard(handler) {
    const [resuming, setResuming] = useState(false);
    const inFlightRef = useRef(false);
    const run = useCallback(async (...args) => {
        if (inFlightRef.current) return;
        inFlightRef.current = true;
        setResuming(true);
        try {
            await handler(...args);
        } finally {
            inFlightRef.current = false;
            setResuming(false);
        }
    }, [handler]);
    return [resuming, run];
}
